import { Outlet, Link } from "react-router";
import React, { Component } from 'react';
import { PrimeReactProvider } from 'primereact/api';
import { withRouter } from "../../ganchos/withRouter";

class LayoutPrincipal extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }   
    render() {
        return (
            <div style={{ backgroundColor: "#343A40", height: "100%" }}> 
               <Outlet {...this.props }/> 
            </div>
        )
    }
}
export default withRouter(LayoutPrincipal);